var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0L9.33333 1.33333L11.338 1.33333C11.7033 1.33333 12 1.63 12 1.99533L12 12.6713C12 13.0367 11.7033 13.3333 11.338 13.3333L0.662 13.3333C0.296667 13.3333 0 13.0367 0 12.6713L0 1.99533C0 1.63 0.296667 1.33333 0.662 1.33333L2.66667 1.33333L2.66667 0L9.33333 0ZM2.66667 2.66667L1.33333 2.66667L1.33333 12L10.6667 12L10.6667 2.66667L9.33333 2.66667L9.33333 4L2.66667 4L2.66667 2.66667ZM4 9.33333L4 10.6667L2.66667 10.6667L2.66667 9.33333L4 9.33333ZM4 7.33333L4 8.66667L2.66667 8.66667L2.66667 7.33333L4 7.33333ZM4 5.33333L4 6.66667L2.66667 6.66667L2.66667 5.33333L4 5.33333ZM8 1.33333L4 1.33333L4 2.66667L8 2.66667L8 1.33333Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 2 1.33333)",
    fill: "currentColor"
  }))));
};
export default SvgTemplate;